import { useState } from "react";

/**
 * Drop-in <img> replacement that:
 *  - Shows a subtle shimmer skeleton until the image bytes arrive
 *  - Fades in when loaded (feels premium on slow networks)
 *  - Lazy-loads + decodes async by default (change with `eager` prop for above-the-fold hero)
 */
export default function LazyImage({ src, alt = "", className = "", eager = false, ...rest }) {
  const [loaded, setLoaded] = useState(false);
  return (
    <div className={`relative overflow-hidden bg-secondary/40 ${className}`}>
      {!loaded && <div className="skeleton absolute inset-0" aria-hidden />}
      <img
        src={src}
        alt={alt}
        loading={eager ? "eager" : "lazy"}
        decoding="async"
        onLoad={() => setLoaded(true)}
        onError={() => setLoaded(true)}
        className={`w-full h-full object-cover img-fade ${loaded ? "is-loaded" : ""}`}
        {...rest}
      />
    </div>
  );
}
